export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14278.d83893a3.jpg";